export default __webpack_public_path__ + "static/media/civ_spy.c85cec50.png";